module.exports = __webpack_public_path__ + "img/ubiqu_white.2b12644e.svg";